import React from 'react';
import PageList from '../../components/PageListAPI'
import { getWorker, deleteWorker } from '../../api/project-worker'
import { Link } from 'react-router-dom';
import { Button } from '@mui/material'
import { useCan } from '../../hooks/useCan';
import { SLUGS } from '../../enum/permissions.enum';

function ProjectWorker(props) {
  const can = useCan()
  const toLinkEnding = React.forwardRef((props1, ref) => (<Link ref={ref} to='worker/ending' {...props1} />));
  return (
    <div className='App-paper'>
      <PageList
        name='project-worker'
        title='Работники на проекте'
        columns={[
          { id: 'surname', name: 'Фамилия', },
          { id: 'name', name: 'Имя' },
          { id: 'patronymic', name: 'Отчество', },
          { id: 'dateStart', name: 'Начало работы', type: 'date', formatDate: 'DD.MM.YYYY' },
          { id: 'dateEnd', name: 'Окончание работы', type: 'date', formatDate: 'DD.MM.YYYY' },
        ]}
        createItem={can(SLUGS.PROJECT.WORKER.MANAGE)}
        deleteItem={can(SLUGS.PROJECT.WORKER.MANAGE)}
        loadAPI={{
          request: getWorker,
          querty: {
          },
          param: {
            id: props.match.params.idProject
          }
        }}
        deleteAPI={deleteWorker(props.match.params.idProject)}
        click={false}
        headerLink={
        can(SLUGS.PROJECT.WORKER.MANAGE)?<Button key='load-grand' component={toLinkEnding} color="primary" >Убрать из проекта</Button>:null
      }
        {...props}
      />
    </div>
  )
};

export default ProjectWorker

